module.exports = __webpack_public_path__ + "img/Editor.a6afbe06.svg";